import { WorkExperience } from "../pages/candidate/CandidateProfileEditNew";

export const validateSingleExperience = (exp: WorkExperience) => {
    const errors: any = {};

    // 🔹 Required fields
    if (!exp.job_title?.trim()) {
        errors.job_title = "Job title is required";
    }

    if (!exp.company_name?.trim()) {
        errors.company_name = "Company name is required";
    }

    if (!exp.start_date) {
        errors.start_date = "Start date is required";
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // 🔹 Start Date Validation
    if (exp.start_date) {
        const start = new Date(exp.start_date);

        if (start > today) {
            errors.start_date = "Start date cannot be in the future";
        }
    }

    // 🔹 End Date Validation (only if not current)
    if (!exp.is_current) {
        if (!exp.end_date) {
            errors.end_date = "End date is required";
        }

        if (exp.start_date && exp.end_date) {
            const start = new Date(exp.start_date);
            const end = new Date(exp.end_date);
            if (end < start) {
                errors.end_date = "End date cannot be before start date";
            }
        }
    }
    return errors;
};